import SchedulerServiceClient from '@/services/SchedulerServiceClient'
import * as types from '@/store/scheduler/mutation-types'
import Patient from '@/entities/Patient'
import Appointment from '@/entities/Appointment'

/**
 * Calls Scheduler service using visit info from Check In View
 * A Visit is comprised of Appointment + Patient entities
 * @param {Object} context
 * @param {String} email
 * @param {String} firstName
 * @param {String} lastName
 * @param {String} phone
 * @param {String} practiceUuid
 */
export const createAppointmentAndPatient = ({ commit }, { email, firstName, lastName, phone, practiceUuid }) => {
  const client = new SchedulerServiceClient()

  // This is the data structure Scheduling API (v2) as POST body
  const dataToSend = {
    patient: {
      email,
      first_name: firstName.trim(),
      last_name: lastName.trim(),
      mobile_phone: phone,
      practice_uuid: practiceUuid
    },
    appointment: {
      source: 'DROP_IN',
      status: 'CHECKED_IN',
      type: 'TELEHEALTH_PP'
    }
  }

  return client.createAppointmentAndPatient(practiceUuid, dataToSend)
    .then(({ data: { body: { patient } }, data: { body: { appointment } } }) => {
      commit(types.SET_PATIENT, new Patient(patient))
      commit(types.SET_APPOINTMENT, new Appointment(appointment))
    })
    .catch((error) => {
      commit(types.SET_PATIENT, error)
      commit(types.SET_APPOINTMENT, error)
    })
}
